import { useState } from 'react';
import SectionHead from './SectionHead';

/* S5 FAQ (page spec S5). Four questions (owner 2026-09-29: "Can I use my
   own curriculum?" first): "What if my course is not in the
   list?" waits for Sandy's answer, and every school-plan mention is out
   (owner 2026-09-29: "don't even mention the whole school one"). Quiet rows
   like /students: a thin line between questions and a chevron that turns.
   Heading in a left column, rows in the rest (both page edges shared). */

const FAQS = [
  {
    q: 'Can I use my own curriculum?',
    a: 'Yes. Pick it from our list, and Buffy shows the SAT skills each unit covers. If yours is not there, tell us which one you teach, from any publisher. We add the curricula teachers ask for most.',
  },
  {
    q: 'Is it really free?',
    a: 'Yes. Brain Buffs is free for teachers.',
  },
  {
    q: 'Do I have to build SAT lessons?',
    a: 'No. Students practice at their own level with adaptive questions, so there’s no whole-class SAT unit to plan and no packet to print. Your curriculum stays your curriculum.',
  },
  {
    q: 'How do students join?',
    a: 'With a class code. You share the 6-letter code, and students type it in to join your class. No IT setup.',
  },
];

function Row({ q, a, i }) {
  const [open, setOpen] = useState(false);
  const id = `cxs-faq-${i}`;
  return (
    <div className="cxs-faq-row">
      <h3 className="cxs-faq-h">
        <button
          type="button"
          className="cxs-faq-q"
          aria-expanded={open}
          aria-controls={id}
          onClick={() => setOpen((o) => !o)}
        >
          <span>{q}</span>
          <svg className="cxs-faq-chev" viewBox="0 0 20 20" width="20" height="20" aria-hidden="true">
            <path d="M5 7.5l5 5 5-5" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </h3>
      <div id={id} className="cxs-faq-a" hidden={!open}>
        <p>{a}</p>
      </div>
    </div>
  );
}

/* Props (schools preview, 2026-09-30) let another page reuse this look with
   its own words. With no props it renders the teacher FAQ exactly as before. */
export default function FaqSection({ items = FAQS, lead = 'Questions', tail = 'teachers ask.' }) {
  return (
    <section className="cx-root cxs-section cxs-faq-sec" aria-labelledby="cxs-faq-h">
      <div className="cxs-wrap cxs-faq">
        <SectionHead id="cxs-faq-h" lead={lead} tail={tail} align="left" />
        <div className="cxs-faq-list">
          {items.map((f, i) => (
            <Row key={f.q} q={f.q} a={f.a} i={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
